export const en = {
    // General
    loading: 'Loading...',
    save: 'Save',
    saveSuccess: 'Saved successfully',
    error: 'An error occurred',
    confirm: 'Confirm',
    cancel: 'Cancel',
    delete: 'Delete',
    edit: 'Edit',
    search: 'Search...',
    date: 'Date',
    description: 'Description',
    amount: 'Amount',
    ai_step_designing: 'Imagining the scene...',
    ai_step_rendering: 'Rendering...',
    ai_step_finalizing: 'Finalizing...',
    aiGenerationFailed: 'Image generation failed. Please check your internet connection and try again.',

    // Dashboard Analytics
    salesOverview: 'Sales Overview (Last 7 Days)',
    dailyRevenue: 'Daily Revenue Trends',
    sales: 'Transaction Volume',
    revenue: 'Realized Revenue',
    totalOrders: 'Total Completed Orders',
    avgOrderPrice: 'Average Order Value (AOV)',
    itemsSold: 'Inventory Items Distributed',
    activeProducts: 'Active SKUs in Catalog',
    viewAll: 'View Full Dataset',
    noData: 'No operational data available',
    today: 'Daily Activity',
    thisWeek: 'Weekly Momentum',
    thisMonth: 'Monthly Performance',
    thisYear: 'Annual Trajectory',

    // Menu / Sidebar
    accounting: 'Accounting',
    overview: 'Overview',
    chartOfAccounts: 'Chart of Accounts',
    journalEntries: 'Journal Entries',
    costCenters: 'Cost Centers',
    reports: 'Reports',
    settings: 'Settings',
    sidebar_openingBalanceEntry: 'Opening Balance Entry',
    openingBalanceEntry: 'Opening Balance Entry',
    vouchers: 'Vouchers',
    cheques: 'Cheques',
    reconciliation: 'Bank Reconciliation',
    accountingSettings: 'Accounting Settings',
    settingsSubtitle: 'Control your restaurant identity and system settings.',
    payrollAndHR: 'Payroll & HR',
    payrollSubtitle: 'Manage payroll runs, attendance, and documents',
    attendanceLastUpdate: 'Last attendance update',
    noPayrolls: 'No payroll runs issued',
    attendanceRecord: 'Attendance Record',
    newPayroll: 'New Payroll',
    totalPaid: 'Total Paid',
    kds: 'Kitchen Display System (KDS)',
    zatcaIntegration: 'ZATCA Compliance Hub',
    paymentManagement: 'Payment Settlements',
    subscription: 'Business Plan & Billing',
    support: 'Concierge Support',
    auth_alreadyHaveAccount: 'Already have an account?',
    auth_loginNow: 'Login Now',
    auth_agreeTerms: 'By creating an account, you agree to DFOOD Terms of Service and Privacy Policy.',

    // Accounting Page
    accountingSystem: 'Accounting System',
    accountingSubtitle: 'Manage chart of accounts, journal entries, and financial settings.',
    accountingGuide: 'Accounting System Guide',
    quickActions: 'Quick Actions',
    newVoucherShort: 'New Voucher',
    journalEntryShort: 'Journal Entry',
    chartOfAccountsShort: 'Chart of Accounts',
    financialReportsShort: 'Financial Reports',
    financialSnapshot: 'Financial Snapshot',
    currentMonthPerformance: 'Current Month Performance',
    operationalStatus: 'Operational Status',
    printCoaPdf: 'Print Chart of Accounts (PDF)',
    arabicName: 'Arabic Name',
    englishName: 'English Name',
    accountTree: 'Account Tree',

    // Overview Tab
    totalRevenue: 'Total Revenue',
    totalExpenses: 'Total Expenses',
    netProfit: 'Net Profit',
    assets: 'Assets',
    liabilities: 'Liabilities',
    equity: 'Equity',
    recentTransactions: 'Recent Transactions',

    // Accounts Tab
    addAccount: 'Add Account',
    accountName: 'Account Name',
    accountCode: 'Account Code',
    accountType: 'Account Type',
    parentAccount: 'Parent Account',

    // Journal Entries Tab
    addEntry: 'Add New Entry',
    totalEntries: 'Total Entries',
    totalDebit: 'Total Debit',
    totalCredit: 'Total Credit',
    entryNumber: 'Entry Number',
    debit: 'Debit',
    credit: 'Credit',
    balance: 'Balance',
    difference: 'Difference',
    saveEntry: 'Save Entry',
    entryCreatedSuccess: 'Entry created successfully',
    unbalancedEntry: 'Entry is unbalanced',
    descriptionRequired: 'Description is required',
    moreFilters: 'More Filters',
    hideFilters: 'Hide Filters',
    chooseDate: 'Please choose a date',
    reversalDate: 'Reversal Date',
    confirmReversal: 'Confirm Reversal',
    reversalReasonPlaceholder: 'Reversal reason (optional)...',
    notes: 'Notes',
    items: 'Items',
    addRow: 'Add Row',

    // Vouchers Tab
    totalVouchers: 'Total Vouchers',
    receiptTotal: 'Receipt Total',
    paymentTotal: 'Payment Total',
    chooseAccount: 'Choose Account',
    itemDescription: 'Line Description',
    viewDetails: 'View Details',
    reverseEntry: 'Reverse Entry',

    // Cheques Tab
    totalCheques: 'Total Cheques',
    pendingAmount: 'Pending Amount',
    clearedAmount: 'Cleared Amount',
    bouncedAmount: 'Bounced Amount',
    inCount: 'Incoming Count',
    outCount: 'Outgoing Count',

    // Reconciliation Tab
    openSessions: 'Open Sessions',
    closedSessions: 'Closed Sessions',

    // Cost Centers Tab
    addCostCenter: 'Add Cost Center',
    centerName: 'Center Name',
    centerCode: 'Center Code',

    // Reports Tab
    taxReport: 'Tax Report',
    trialBalance: 'Trial Balance',
    pnl: 'Income Statement',
    balanceSheet: 'Balance Sheet',
    cashFlow: 'Cash Flow',
    agingReport: 'Aging Report',
    customerStatement: 'Customer Statement',
    supplierStatement: 'Supplier Statement',
    exportExcel: 'Export Excel',
    printPdf: 'Print / PDF',
    fromDate: 'From',
    toDate: 'To',
    chooseCustomer: 'Choose Customer...',
    chooseSupplier: 'Choose Supplier...',
    chooseCostCenter: 'Choose Cost Center',
    allCostCenters: 'All Cost Centers',
    reportPeriod: 'Report Period',
    customPeriod: 'Custom Period',
    year: 'Year',
    reportOptions: 'Display Options',
    reportLevel: 'Level',
    showZeroBalance: 'Show Zero Balance Accounts',
    viewReport: 'View Report',
    financialStatements: 'Financial Statements',
    detailedAccountReports: 'Detailed Account Reports',
    taxAndCustomerReports: 'Tax & Customer Reports',
    trial_balance_desc: 'Trial balance with balances and totals by tree levels',
    pnl_desc: 'Income statement - Profit & Loss for the selected financial period',
    balance_sheet_desc: 'Balance sheet - Assets, liabilities, and equity',
    cash_flow_desc: 'Cash flow statement (receipts and payments for all funds)',
    accountStatement: 'Account Statement',
    account_statement_desc: 'Specific account movement with opening balance and running balance per transaction',
    general_journal_desc: 'Detailed journal entries for all accounting transactions in chronological order',
    expenseAnalysis: 'Expense Analysis',
    expense_analysis_desc: 'Detailed view of all expenses classified by main expense account',
    tax_report_desc: 'Official tax declaration draft including output and input tax',
    agingReceivable: 'Aging Receivables',
    aging_receivable_desc: 'Analysis of overdue customer balances by period (30-60-90+ days)',
    reportsGuide: 'Accounting Reports Guide',
    reportsGuideSubtitle: 'Choose the right report to review your restaurant financial performance accurately.',
    backToGuide: 'Back to Guide',
    generalLedger: 'General Ledger',
    general_ledger_desc: 'Summary of all accounts with opening, debit, credit and closing balances',
    accountLedgerDetail: 'Account Ledger Detail',
    account_ledger_detail_desc: 'Detailed movement of a specific account with running balance',
    cumulativeBalance: 'Cumulative Balance',
    finalBalance: 'Final Balance',
    reportDetails: 'Report Details',
    standardFinancialReports: 'Standard Financial Reports',
    transactionDescription: 'Transaction Description',
    transactionDate: 'Transaction Date',
    opening: 'Opening',
    movement: 'Movement',
    closing: 'Closing',
    details: 'Details',
    runningBalance: 'Balance',
    expenseBreakdownDetailed: 'Detailed Expense Breakdown by Account',
    agingReceivables: 'Customer Aging Receivables',
    days: 'days',
    total: 'Total',
    purchases: 'Purchases',
    vat: 'VAT',
    totalSales: 'Total Sales',
    totalPurchases: 'Total Purchases',
    netVatDue: 'Net VAT Due',
    vatPayable: 'Amount Payable to Authority',
    vatRefundable: 'Credit Balance (Refundable)',
    standardVatSales: 'Standard Rate Sales (15%)',
    zeroVatSales: 'Zero-Rated Sales (0%)',
    exemptSales: 'Exempt Sales',
    standardVatPurchases: 'Standard Rate Purchases (15%)',
    zeroVatPurchases: 'Zero-Rated Purchases (0%)',
    exemptPurchases: 'Exempt Purchases',
    error_fetching_report: 'Failed to load report, please check server connection',

    // Vouchers
    vouchersTitle: 'Accounting Vouchers',
    addVoucher: 'Add Voucher',
    searchByStatus: 'Search by Status',
    voucherType: 'Voucher Type',
    vouchersTable_no: 'Voucher No.',
    vouchersTable_type: 'Type',
    vouchersTable_date: 'Date',
    vouchersTable_amount: 'Amount',
    vouchersTable_status: 'Status',
    vouchersTable_contact: 'Contact / Name',
    vouchersTable_account: 'Account',
    vouchersTable_actions: 'Actions',
    receiptVoucher: 'Receipt Voucher',
    paymentVoucher: 'Payment Voucher',
    receivedFrom: 'Received From',
    paidTo: 'Paid To',
    onAccountOf: 'On Account Of',
    paymentMethod: 'Payment Method',
    stamp: 'Stamp',
    saveAsDraft: 'Save as Draft',
    postVoucher: 'Save & Post',
    saving: 'Saving...',
    referenceNumberLabel: 'Reference Number',
    openingBalance: 'Opening Balance',
    ref: 'Ref',
    costCenter: 'Cost Center',
    code: 'Code',
    netIncome: 'Net Income',
    retainedEarnings: 'Retained Earnings',
    depositInto: 'Deposit Into (Cash/Bank Account)',
    withdrawFrom: 'Withdraw From (Cash/Bank Account)',
    sourceAccount: 'Revenue / Source Account',
    beneficiaryAccount: 'Expense / Beneficiary Account',
    contactNameLabel: 'Contact / Name (Optional)',
    descriptionLabel: 'Description / Notes',
    confirmPostVoucher: 'Are you sure you want to post this voucher? This action cannot be undone.',
    noVouchers: 'No vouchers',
    newVoucher: 'Create New Voucher',

    // Cheques
    chequesTitle: 'Cheque Management',
    addCheque: 'Add Cheque',
    chequeIn: 'Incoming Cheque (Receipt)',
    chequeOut: 'Outgoing Cheque (Payment)',
    chequeNumber: 'Cheque Number',
    dueDate: 'Due Date',
    issueDate: 'Issue Date',
    bankName: 'Bank Name',
    payeeName: 'Payee / Drawn From',
    chequeStatus: 'Cheque Status',
    pending: 'Pending',
    collected: 'Collected',
    cleared: 'Cleared',
    deposited: 'Deposited',
    bounced: 'Bounced / Rejected',
    cancelled: 'Cancelled',
    createJournalEntry: 'Create Auto Journal Entry',
    updateStatus: 'Update Status',
    confirmStatusUpdate: 'Confirm Status Update',
    noCheques: 'No cheques recorded',

    // Reconciliation
    bankReconciliation: 'Bank Reconciliation',
    startReconciliation: 'Start New Reconciliation',
    statementBalance: 'Statement Balance',
    systemBalance: 'System Balance',
    match: 'Match',
    adjust: 'Adjust',
    reconciliationSessions: 'Reconciliation Sessions',
    openSession: 'Open Session',
    closedSession: 'Completed Session',
    uploadStatement: 'Upload Statement (Excel)',
    matchSystemEntry: 'Match with System Entry',
    createAdjustment: 'Create Adjustment Entry',
    targetAccount: 'Target Account',
    reconciliationSuccess: 'Reconciliation completed successfully',
    unmatchedStatementLines: 'Unmatched Statement Lines',
    unmatchedSystemLines: 'Unmatched System Lines',

    // Manual Entries
    newEntry: 'New Journal Entry',
    entryDescription: 'Entry Description',
    chooseAccountFirst: 'Please select an account for all rows',

    // Guide
    accountingGuideTitle: 'Integrated Accounting System Guide',
    guide_coa_title: 'Chart of Accounts (COA)',
    guide_coa_desc:
        'Build your account structure (assets, liabilities, revenue, expenses). You can use "Install Defaults" to get started quickly.',
    guide_vouchers_title: 'Vouchers & Entries',
    guide_vouchers_desc:
        'Record your financial transactions manually via journal entries or use vouchers (receipt, payment) to document cash operations.',
    guide_costs_title: 'Cost Centers',
    guide_costs_desc: 'Link your restaurant departments to specific cost centers to know each department profitability accurately.',
    guide_reports_title: 'Financial Reports',
    guide_reports_desc:
        'Generate trial balance, income statement, and general ledger at any time to monitor your financial performance.',
    tip_auto_entries:
        'The system automatically creates journal entries when sales are completed if accounting routing settings are configured.',
    tip_reverse_entry:
        'The "Reverse Entry" feature allows you to correct accounting errors with one click while maintaining the audit trail.',
    tip_cost_center:
        'Enforcing "Cost Center" on accounts ensures no expense is recorded without proper allocation.',
    sfda_records_years:
        'Accounting records must be retained for at least 5 years to comply with ZATCA requirements.',
    sfda_vat_link:
        'Accounting entries are automatically linked to electronic invoices to ensure tax declaration matching.',
    // Settings Tab
    generalSettings: 'General Settings',
    fiscalYearClosing: 'Fiscal Year Closing',
    lockDate: 'Period Lock Date',
    lockDateHint: 'No entries will be allowed before this date',
    closeYearButton: 'Start Closing Procedures',
    defaultAccounts: 'Default Accounts',
    salesAccount: 'Sales Account',
    cashAccount: 'Cash Account',
    bankAccount: 'Bank Account',
    taxAccount: 'Tax Account',
    inventoryAccount: 'Inventory Account',
    cogsAccount: 'Cost of Goods Sold Account',
    defaultAccountsHint: 'Link default accounts here to enable automatic journal entries.',
    closeFiscalYear: 'Close Fiscal Year',
    closeYearDesc: 'Zero out revenue and expenses and carry forward the balance',
    startClosing: 'Start Closing Procedures',
    confirmCloseYear: 'Are you sure you want to close the fiscal year? This action cannot be undone.',
    closeYearSuccess: 'Fiscal year closed successfully!',
    fillAllFields: 'Please fill all required fields',
    closeYearWarning: 'An automatic entry will be created to zero out all income statement accounts.',
    closeYearConfirm:
        'Warning: This will zero out all revenue and expense accounts and carry forward the balance to retained earnings. Are you sure?',

    // Advanced Accounting Tools
    manageFiscalPeriods: 'Manage Fiscal Periods',
    openPeriod: 'Open Fiscal Period',
    openPeriodDesc: 'Reopen a closed fiscal period for editing',
    accountingTools: 'Advanced Accounting Tools',
    toolsSubtitle: 'Maintenance and rebalancing operations',
    recalculateBalances: 'Recalculate Balances',
    recalculateDesc: 'Update account balances based on entries',
    auditLog: 'Audit Log',
    transferBalances: 'Transfer Balances',
    transferDesc: 'Transfer balance from one account to another',
    generalConfiguration: 'System Configuration',
    vatRate: 'Default VAT Rate (%)',
    currency: 'Base Currency',
    backupData: 'Data Backup',
    confirmRecalculate:
        'Are you sure? All balances will be recalculated from scratch. This may take a few minutes.',
    transferSuccess: 'Balance transferred successfully',
    fromAccount: 'From Account',
    toAccount: 'To Account',
    welcomeTitle: 'Smart Accounting',
    welcomeBody: 'Integrated financial management including entries, vouchers, and cheques.',
    none: 'None',
    main: 'Main',
    sub: 'Sub',
    nature: 'Nature',
    classification: 'Classification',
    descriptionEn: 'English Name',
    stopAccount: 'Stop (Archive)',
    enforceBranch: 'Enforce Branch',
    enforceCostCenter: 'Enforce Cost Center',
    chartTree: 'Chart of Accounts',
    new: 'New',
    noAccounts: 'No accounts',
    installDefaults: 'Install Default Chart of Accounts',
    linkedCategories: 'Linked Categories',
    noCategories: 'No categories',
    reversed: 'Reversed',
    reversalFor: 'Reversal for',
    reverseEntryHint: 'A new entry with the same values but reversed accounts will be created.',
    checks: 'Cheques',
    halkAnalytics: 'Waste Analysis Report',
    physicalCount: 'Physical Count',

    // Additional Keys
    netVatPayable: 'Net VAT Payable (to Authority)',
    netVatRefundable: 'Net VAT Refundable (from Authority)',
    resetBalance: 'Reset Balance',
    closingDate: 'Closing Date',
    retainedEarningsAccount: 'Retained Earnings Account',
    confirmClose: 'Confirm Closing',
    usageGuide: 'Usage Guide',
    guide_step1_title: '1. Set Up Chart of Accounts',
    guide_step1_desc: 'Create main and sub-accounts to properly classify your financial transactions.',
    guide_step2_title: '2. Link Default Accounts',
    guide_step2_desc:
        'From the settings screen, link Sales, Cash, and Bank accounts to enable automatic entries.',
    guide_step3_title: '3. Enter Opening Balances',
    guide_step3_desc: 'Use a journal entry to record opening balances when starting on the system.',
    guide_step4_title: '4. Vouchers & Entries',
    guide_step4_desc: 'Record payment and receipt vouchers and journal entries for non-automatic transactions.',
    guide_step5_title: '5. Reports & Declarations',
    guide_step5_desc: 'Generate trial balance and tax declarations regularly to monitor financial performance.',
    // Accounting Reports Guide
    generalJournal: 'General Journal',
    reportsHistory: 'Reports History',
    showZero: 'Show Zero Balances',
    apply: 'Apply',
    preparedBy: 'Prepared By',
    approvedBy: 'Approved By',
    period: 'Period',
    generatedOn: 'Generated On',
    restaurantName: 'Business Name',
    taxNumber: 'Tax Number',
    commercialReg: 'Commercial Registration',
    noTableFound: 'No data found for export',
    account: 'Account',
    // Asset Management
    assetsManagement: 'Fixed Assets',
    addAsset: 'Add Asset',
    assetName: 'Asset Name',
    purchaseDate: 'Purchase Date',
    purchaseCost: 'Purchase Cost',
    usefulLife: 'Useful Life (months)',
    salvageValue: 'Salvage Value',
    runDepreciation: 'Run Depreciation',
    depreciationSuccess: 'Depreciation run successfully',

    // Payroll
    payroll: 'Payroll',
    runPayroll: 'Issue Payroll',
    employee: 'Employee',
    basicSalary: 'Basic Salary',
    netSalary: 'Net Salary',

    // Tables Page
    tablesManagement: 'Table Management',
    tablesSubtitle: 'Design your restaurant layout or manage tables as a list.',
    visualLayout: 'Visual Layout',
    listMode: 'List',
    saveLayout: 'Save Layout',
    addTable: 'New Table',
    available: 'Available',
    occupied: 'Occupied',
    capacity: 'Capacity',
    tableName: 'Table Name/Number',
    shape: 'Shape',
    width: 'Width (px)',
    height: 'Height (px)',
    roundedSquare: 'Square',
    circle: 'Circle',
    rectangle: 'Rectangle',
    showQr: 'Show QR',
    preview: 'Preview',
    dragToMove: 'Drag to move tables • Double-click to edit',
    emptySpace: 'Empty Space',
    emptySpaceSubtitle: 'Add tables and start designing your restaurant layout',
    noTables: 'No tables',
    scanQr: 'Scan code to view menu',
    saveImage: 'Save Image',
    deleteTableConfirm: 'Are you sure you want to delete',
    layoutSaved: 'Table layout saved successfully!',
    layoutSaveError: 'Failed to save layout',
    editTable: 'Edit Table',

    // Customers Page
    customersManagement: 'Customer Management',
    customersSubtitle: 'Manage customer financial profiles and credit limits.',
    searchPlaceholder: 'Search by name or email...',
    noCustomers: 'No customers',
    noCustomersFound: 'No matching results found.',
    editFinancialData: 'Edit Financial Data',
    editFinancialDataTitle: 'Edit Financial Data:',
    openingBalanceWarning:
        'Note: Editing the opening balance should be done through an opening entry in the accounting system to ensure balance.',
    creditLimitLabel: 'Credit Limit (SAR)',
    notAvailable: 'Not Available',

    // Dashboard
    dashboard: 'Dashboard',
    goodMorning: 'Good Morning',
    hello: 'Welcome',
    viewLiveMenu: 'View Live Menu',
    todaysOrders: "Today's Orders",
    pendingOrders: 'Pending Orders',
    todaysRevenue: "Today's Revenue",
    completedOrders: 'Completed Orders',
    currentOrders: 'Current Orders',
    newOrdersWillAppearHere: 'New orders will appear here automatically',
    noRecentOrders: 'No recent orders',

    // Orders Page
    orderManagement: 'Order Management',
    orderManagementSubtitle: 'Track, manage, and execute all your orders from one place.',
    searchOrders: 'Search by customer name or order number...',
    all: 'All',
    preparing: 'Preparing',
    completed: 'Completed',
    page: 'Page',
    of: 'of',
    noOrdersFound: 'No orders found',
    tryChangingFilters: 'Try changing filters or search terms.',
    orderDetails: 'Order Details',
    customer: 'Customer',
    table: 'Table',
    guestCustomer: 'Guest Customer',
    notSpecified: 'Not Specified',
    orderedItems: 'Ordered Items',
    unknownProduct: 'Unknown Product',
    noItems: 'No items in this order',
    generalNotes: 'General Notes',
    changeStatus: 'Change Order Status:',
    printInvoice: 'Print Invoice',
    print: 'Print',
    saveChanges: 'Save Changes',
    errorUpdateStatus: 'Failed to update status',

    // Vendor Layout / Sidebar
    appName: 'DFOOD',
    updating: 'Updating...',
    refresh: 'Refresh',
    installApp: 'Install App',
    manageProfile: 'Manage Your Profile',
    backToAdmin: 'Back to Admin Panel',
    pos: 'Point of Sale (POS)',
    salesReports: 'Sales Reports Overview',
    orders: 'Order Management',
    customers: 'Customers',
    purchasesReports: 'Procurement Reports Overview',
    strategicReports: 'Strategic Reports',
    advancedReports: 'Advanced Reports',
    suppliers: 'Suppliers Management',
    inventory: 'Inventory Management',
    menu: 'Menu Management',
    tables: 'Tables Management',
    staff: 'Staff Management',
    loyalty: 'Loyalty Program',

    // Menu Page
    menuManagement: 'Menu Management',
    menuManagementSubtitle: 'Organize your restaurant items and products here.',
    addCategory: 'Add New Category',
    emptyMenu: 'Your menu is empty!',
    emptyMenuSubtitle:
        'Start by adding categories (e.g., Appetizers, Main Courses) then add products.',
    addFirstCategory: 'Add First Category',
    editCategory: 'Edit Category',
    deleteCategoryConfirm: 'Are you sure you want to delete this category? All products inside will be deleted.',
    addProduct: 'Add New Product',
    editProduct: 'Edit Product',
    deleteProductConfirm: 'Are you sure you want to delete this product?',
    productInfo: 'Product Info',
    ingredientsInventory: 'Ingredients & Inventory',
    name: 'Name',
    magicDescription: 'Magic Description',
    typeDescription: 'Write a description or use Magic Description...',
    price: 'Price',
    spicy: 'Spicy',
    vegan: 'Vegan',
    featured: 'Featured',
    image: 'Image',
    product: 'Product',
    category: 'Category',
    orUseAI: 'Or choose from AI tools below:',
    generating: 'Generating...',
    generateWithAI: 'Generate with AI',
    searchInternet: 'Search Internet',
    inventoryHint:
        'Link this product (dish) to its ingredients from inventory. Quantities will be deducted from inventory when this product is sold.',
    loadingItems: 'Loading items...',
    chooseItem: 'Choose Ingredient...',
    quantity: 'Quantity',
    gram: 'Gram',
    kg: 'Kg',
    pcs: 'Piece',
    ml: 'ml',
    liter: 'Liter',
    addIngredient: 'Add Ingredient',
    unavailable: 'Unavailable',
    stock: 'Stock',
    addNewProduct: 'Add New Product',
    noProductsInCategory: 'No products in this category yet.',
    enterProductNameAI: 'Please enter a product name first to generate an appropriate image',
    enterProductName: 'Please enter the dish name first',
    units: 'Units',
    saveError: 'Save operation failed.',
    deleteError: 'Delete operation failed.',

    // Menu Import / Export
    menuImportExport: 'Import / Export Menu',
    importFromExcel: 'Import from File',
    exportToExcel: 'Export to File',
    downloadTemplate: 'Download Blank Template',
    downloadTemplateDesc: 'Download a blank CSV file with proper columns and fill in your items',
    importMenuTitle: 'Import Menu from CSV File',
    importMenuDesc: 'Upload a CSV file containing your categories and products. You can download the blank template first.',
    importMode: 'Import Mode',
    importModeMerge: 'Merge (Add & Update)',
    importModeMergeDesc: 'New items are added and existing ones are updated by name',
    importModeReplace: 'Full Replacement',
    importModeReplaceDesc: 'Delete all existing items and replace with the new file',
    replaceWarning: '⚠️ Warning: This will permanently delete all current categories and products!',
    chooseFile: 'Choose CSV File',
    changeFile: 'Change File',
    selectedFile: 'Selected File',
    fileSize: 'Size',
    startImport: 'Start Import',
    importing: 'Importing...',
    importSuccess: 'Import completed successfully!',
    importResults: 'Import Results',
    categoriesCreated: 'New Categories',
    productsCreated: 'New Products',
    productsUpdated: 'Updated Products',
    rowsProcessed: 'Rows Processed',
    importErrors: 'Errors',
    rowNumber: 'Row',
    exportingMenu: 'Exporting menu...',
    exportSuccess: 'Menu exported successfully!',
    noMenuToExport: 'No items to export. Add items first.',
    importConfirmReplace: 'Are you sure you want to replace all items? This action cannot be undone.',
    templateDownloaded: 'Template downloaded',

    // Settings Page
    restaurantSettings: 'Restaurant Settings',
    generalIdentity: 'Restaurant Identity',
    branches: 'Branches',
    paymentMethods: 'Payment',
    printerSettings: 'Printer Settings',
    notifications: 'Notifications',
    restaurantLogo: 'Restaurant Logo',
    logoHint:
        'This logo will appear to customers at the top of the digital menu. We recommend using a clear, high-resolution image (supports up to 10MB).',
    changeLogo: 'Change Image',
    email: 'Email',
    phone: 'Restaurant Phone',
    address: 'Address',
    aboutRestaurant: 'About Restaurant (short description)',
    usd: 'Dollar',
    timezone: 'Timezone',
    restaurantBranches: 'Restaurant Branches',
    branchesSubtitle: 'Add and manage your different restaurant branches.',
    addBranch: 'Add Branch',
    active: 'Active',
    inactive: 'Inactive',
    noBranches: 'No branches added currently',
    paymentSubtitle:
        'Enable the payment methods you want to offer your customers and link your API keys.',
    cashPayment: 'Cash / Table Payment',
    apiRequired: 'Requires direct API integration',
    printSettingsTitle: 'Print & Invoice Settings',
    printSettingsSubtitle:
        'Customize invoice design, set up thermal printers, and control printed content.',
    connectionSettings: 'Connection Settings',
    printerType: 'Printer Type',
    noPrinter: 'No Printer (PDF Download Only)',
    browserPrint: 'System Default Printer (Browser Print)',
    networkPrint: 'Network Printer (IP)',
    printerIp: 'Printer IP Address',
    printerPort: 'Port Number',
    autoPrintOrder: 'Auto-print on order acceptance',
    invoiceDesign: 'Invoice Design',
    thermalReceipt: 'Thermal Receipt (POS 80mm)',
    standardInvoice: 'Standard Invoice (A4 PDF)',
    invoiceFooter: 'Invoice Footer Text',
    showLogoInvoice: 'Show Logo on Invoice',
    showQrInvoice: 'Show QR Code for E-Invoice',
    soon: 'Coming Soon',
    advancedNotifications: 'Advanced Notification Management',
    imageTooLarge: 'Logo is too large. Please choose an image under 5MB.',
    saveBranchError: 'Failed to save branch data',
    deleteBranchConfirm: 'Are you sure you want to delete this branch?',
    deleteBranchError: 'Failed to delete branch',
    editBranch: 'Edit Branch Data',
    branchName: 'Branch Name',
    branchEmail: 'Branch Email',
    showOnInvoice: 'Show this information on customer invoice',
    enableBranch: 'Enable Branch (visible to customers)',
    officialReport: 'Official Report',
    financialStatement: 'Financial Statement',
    dateRange: 'Date Range',
    closingBalance: 'Closing Balance',
    journalVoucher: 'Journal Entry',
    totalAssets: 'Total Assets',
    totalLiabilities: 'Total Liabilities',
    totalEquity: 'Total Equity',
    totalLiabilitiesAndEquity: 'Total Liabilities & Equity',
    liabilitiesAndEquity: 'Liabilities & Equity',
    currencySymbol: 'SAR',
    refreshData: 'Refresh Data',
    draft: 'Draft',
    posted: 'Posted',
    receipt: 'Receipt',
    payment: 'Payment',
    noDataToExport: 'No data to export',
    voucherPostedSuccess: 'Voucher posted successfully',
    voucherDraftSuccess: 'Voucher saved as draft',
    postedSuccess: 'Posted successfully',
    chequeCreatedSuccess: 'Cheque saved successfully',
    clearFilters: 'Clear Filters',
    autoEntryNotice: 'An automatic journal entry will be created to document this operation.',
    adjustmentSuccess: 'Entry created and matched',
    pendingChequesIn: 'Pending Cheques (Incoming)',
    pendingChequesOut: 'Cheques Due (Outgoing)',
    openReconciliations: 'Open Reconciliations',
    defaultCoaSuccess: 'Default chart of accounts created successfully',
    failedLoadAccounts: 'Failed to load accounts',
    parent: 'Parent',
    noCostCenters: 'No cost centers',
    transferDescription: 'Transfer description',
    confirmTransfer: 'Confirm Transfer',
    fillFields: 'Please fill required fields',
    chequeStatusUpdated: 'Cheque status updated',
    chequeInShort: 'Incoming (Receipt)',
    chequeOutShort: 'Outgoing (Payment)',
    chequeType: 'Cheque Type',
    analyzingMenu: 'Analyzing menu with AI...',
    aiMenuOptimization: 'Menu Optimization',
    aiMenuSubtitle: 'Smart recommendations to increase profits and improve performance',
    refreshAnalysis: 'Refresh Analysis',
    pricingRecommendations: 'Pricing Recommendations',
    menuEngineering: 'Menu Engineering',
    productLifecycle: 'Product Lifecycle',
    crossSellOpportunities: 'Cross-Sell Opportunities',
    seasonalRecommendations: 'Seasonal Recommendations',
    totalProducts: 'Total Products',
    totalProfit: 'Total Profit',
    profitMargin: 'Profit Margin',
    topPerformers: 'Top Performers',
    analyzedProducts: 'Analyzed Products',
    needsAdjustment: 'Needs Adjustment',
    increaseDecrease: 'Increase / Decrease',
    aiPricingRecommendations: 'AI Pricing Recommendations',
    confidence: 'Confidence',
    high: 'High',
    medium: 'Medium',
    low: 'Low',
    currentPrice: 'Current Price',
    suggestedPrice: 'Suggested Price',
    projectedMargin: 'Projected Margin',
    stars: 'Stars',
    starsDesc: 'High sales + High margin',
    plowhorses: 'Plowhorses',
    plowhorsesDesc: 'High sales + Low margin',
    puzzles: 'Puzzles',
    puzzlesDesc: 'Low sales + High margin',
    dogs: 'Dogs',
    dogsDesc: 'Low sales + Low margin',
    noMenuEngineeringData: 'No menu engineering data',
    checkData: 'Make sure you have sales data',
    introduction: 'Introduction',
    growth: 'Growth',
    maturity: 'Maturity',
    decline: 'Decline',
    daysOnMenu: 'Days on Menu',
    day: 'day',
    crossSellSubtitle: 'Products frequently ordered together',
    times: 'times',
    suggestedDiscount: 'Suggested Discount',
    winter: 'Winter',
    spring: 'Spring',
    summer: 'Summer',
    autumn: 'Autumn',
    currentSeason: 'Current Season',
    promoteThese: 'Promote These',
    introduceNew: 'Suggested New Items',
    discountOrRemove: 'Discount or Remove',
    margin: 'Margin',
    underperformers: 'Underperformers',
    hiddenGems: 'Hidden Gems',
    recommendation: 'Recommendation',

    // AI Consultant Page
    ai_title: 'AI Management Assistant',
    ai_subtitle: 'AI-powered strategic insights to improve your restaurant performance',
    ai_loading: 'Starting AI engine...',
    ai_failedTitle: 'Failed to Load Data',
    ai_failedDesc: 'Sorry, we could not fetch AI analytics at this time. Please ensure you have sufficient data (orders, sales) in your restaurant.',
    ai_retry: 'Try Again',
    ai_healthScore: 'Operational Health Score',
    ai_healthGood: 'Excellent performance and low risks',
    ai_healthImprove: 'There are opportunities for improvement in operations',
    ai_topRecommendation: 'Top Strategic Recommendation',
    ai_noRecommendation: 'No recommendations currently',
    ai_executeNow: 'Execute Now',
    ai_menuMatrix: 'Menu Matrix',
    ai_items: 'items',
    ai_stars: 'Stars',
    ai_starsDesc: 'High profit and very popular',
    ai_plowhorses: 'Plowhorses',
    ai_plowhorsesDesc: 'Popular but limited profit',
    ai_puzzles: 'Puzzles',
    ai_puzzlesDesc: 'High profit and low popularity',
    ai_dogs: 'Dogs',
    ai_dogsDesc: 'Low profit and popularity',
    ai_criticalAnalysis: 'Critical Item Analysis',
    ai_peakPerformance: 'Peak Hours Performance',
    ai_crowdForecast: 'Crowd Forecast',
    ai_expectedPeak: 'Expected peak at hour',
    ai_customerVoice: 'Customer Voice',
    ai_positive: 'Positive',
    ai_basedOn: 'Based on',
    ai_reviews: 'reviews',
    ai_risksTitle: 'Risks & Missed Opportunities',
    ai_lowStock: 'Low Stock',
    ai_itemsNeedSupply: 'Items need restocking',
    ai_compliance: 'Compliance & Standards',
    ai_compliant: 'Compliant at',
    ai_aiTip: 'AI Tip:',
    ai_lowStockTip: 'Securing inventory is the top priority right now to avoid breaking the sales cycle.',
    ai_stockGoodTip: 'Everything looks great in terms of inventory, focus on improving customer experience.',
    ai_strategicRoadmap: 'Strategic Roadmap',
    ai_demandForecast: 'Demand Forecast',
    ai_rising: 'Rising 📈',
    ai_falling: 'Falling 📉',
    ai_stable: 'Stable ↔️',
    ai_next7Days: 'Next 7 days forecast',
    ai_orders: 'orders',
    ai_accuracy: 'Accuracy',
    ai_forecastNote: '* Forecast is based on analyzing order patterns from the last 60 days considering weekdays.',
    ai_week: 'Week',
    ai_month: 'Month',
    ai_3months: '3 Months',
    ai_chatTitle: 'Financial Consultant (Live)',
    ai_chatWelcome: 'Welcome! I am your AI financial consultant. You can ask me about your sales, payroll, or any financial details of your restaurant. How can I help you today?',
    ai_chatError: 'Sorry, an error occurred while processing your request 😔',
    ai_chatPlaceholder: 'Ask the financial consultant...',
    ai_guideTitle: 'AI Management Assistant Guide (AI Insight)',
    ai_guideStep1Title: 'Understanding the Health Score',
    ai_guideStep1Desc: 'Gives you a quick overview of your operational quality. The higher the score, the healthier your restaurant operations.',
    ai_guideStep2Title: 'Live Financial Consultant',
    ai_guideStep2Desc: 'Use the chat icon at the bottom to talk to your financial data directly.',
    ai_guideStep3Title: 'Peak Hours Forecast',
    ai_guideStep3Desc: 'The system analyzes the past to predict future pressure so you can schedule staff and prepare ingredients in advance.',
    ai_guideStep4Title: 'Strategic Roadmap',
    ai_guideStep4Desc: 'Practical AI-suggested steps to improve profitability and avoid operational risks.',
    ai_tip1: 'Try asking the assistant: "How were my sales this month compared to last month?"',
    ai_tip2: 'Ask the assistant about "payroll" to learn total financial expenses for staff.',
    ai_tip3: 'Demand forecasting helps you reduce raw material waste by up to 20%.',
    ai_dayLabel: 'Day',

    // Sidebar Navigation
    sidebar_aiConsultant: 'Intelligent Management Assistant (AI)',
    sidebar_operations: 'Operations & Service',
    sidebar_inventoryMenu: 'Menu & Inventory',
    sidebar_governance: 'Governance & Finance',
    sidebar_hqConsole: 'HQ Console (Corporate)',
    sidebar_compliance: 'Compliance & Quality (SFDA)',
    sidebar_marketingGrowth: 'Marketing & Growth',
    sidebar_technicalAdmin: 'Administration & Integration',
    sidebar_reputation: 'Reputation Management',
    sidebar_queueManagement: 'Queue Management',
    sidebar_waiterApp: 'Waiter App',
    sidebar_recipeCosting: 'Recipe Costing',
    sidebar_lowStockAlerts: 'Low Stock Alerts',
    sidebar_purchaseInvoices: 'Purchase Invoices',
    sidebar_purchaseReports: 'Purchases Reports',
    sidebar_purchaseReturns: 'Purchase Returns',
    sidebar_supplierStatement: 'Supplier Statement',
    sidebar_fixedAssets: 'Fixed Assets',
    sidebar_payrollHR: 'Payroll & HR',
    sidebar_taxDeclaration: 'Tax Declaration (ZATCA)',
    sidebar_reportsOverviewSales: 'Sales Performance Overview',
    sidebar_reportsOverviewPurchases: 'Procurement Reports Overview',
    sidebar_branchManagement: 'Franchise & Branch HQ',
    sidebar_hqDashboard: 'HQ Consolidated Dashboard',
    sidebar_hqAccountingCenter: 'HQ Accounting Center',
    sidebar_advancedReports: 'Advanced Reports',
    sidebar_assets: 'Fixed Assets',
    batchManagement: 'Quality Batch Control',
    haccpChecks: 'Safety (HACCP) Audits',
    trainingRecords: 'Staff Training Records',
    sidebar_purchasesGroup: 'Procurement Strategy',
    sidebar_customers: 'Guest Loyalty Database',
    sidebar_consolidatedReports: 'Consolidated Group Reports',
    sidebar_aiMenuOptimization: 'AI Menu Optimization',
    sidebar_kioskSettings: 'Self-Service Kiosk Settings',
    sidebar_integrations: 'Platform Integrations',
    sidebar_deliveryStatements: 'Delivery Account Statements',
    sidebar_backupRestore: 'Data Backup & Recovery',
    sidebar_backup: 'System Backup',
    sidebar_subscription: 'Subscription & Billing',
    sidebar_paymentSettings: 'Payment Settings',
    sidebar_securityPrivacy: 'Security & Privacy Status',
    sidebar_firewallActive: 'Active Firewall - Fully Secured',
    sidebar_aesEncrypted: 'AES-256 Encrypted',
    sidebar_lastBackup: 'Last Backup at:',
    sidebar_complianceHealth: 'Compliance & Health Hub',
    sidebar_aiDecisionSupport: 'AI Decision Support',
    sidebar_strategicAdvice: 'Strategic Recommendation',
    sidebar_analyzingData: 'Analyzing your operational data to provide insights...',
    sidebar_viewFullAnalysis: 'View Deep Analysis',
    sidebar_onboardingGuide: 'Launch Guide',
    sidebar_systemHealth: 'Technical Health Score',
    sidebar_trainingRecords: 'Staff Training Records',
    sidebar_complianceAI: 'Compliance AI Monitoring',
    sidebar_payroll: 'Payroll Management',
    sidebar_kioskManagement: 'Kiosk Management',
    sidebar_floorPlan: 'Floor Plan Layout',
    tablesLayout: 'Tables Layout',
    marketing: 'Marketing',

    // Menu / General Navigation
    logout: 'Logout',

    // Dashboard extra keys
    dash_goodMorning: 'Good Morning',
    dash_goodEvening: 'Good Evening',
    dash_restaurantPrefix: 'Business:',
    dash_loadingRestaurant: 'Connecting to Restaurant...',
    dash_posLabel: 'Sales (POS)',
    dash_smartConsultant: 'Management AI',
    dash_kitchenDisplay: 'Kitchen Ops (KDS)',
    dash_financialReports: 'Financial Insights',
    dash_tableHeatmap: 'Occupancy Heatmap',
    dash_quiet: 'Stable',
    dash_active: 'High Demand',
    dash_loadingDashboard: 'System failed to load dashboard data.',
    dash_optimal: 'Optimal',
    dash_excellent: 'Excellent',
    dash_techHealth: 'Technical Health Score',

    // Settings Page Tabs & Sections
    settings_generalSection: 'Core Identity',
    settings_menuOrdering: 'Ordering System',
    settings_menuSlides: 'Marketing Banners',
    settings_qrSettings: 'QR Connectivity',
    settings_financeOps: 'Financial Controls',
    settings_kitchenPrinters: 'Order Notification Services',
    settings_zatcaLink: 'ZATCA Compliance',
    settings_otherSection: 'General Admin',
    settings_dataPrivacy: 'Data Privacy & Vault',
    settings_security2fa: 'Security (2FA)',
    settings_help: 'Concierge & Help',
    settings_securityTitle: 'Advanced Security Settings',
    settings_securityDesc: 'Protect your business vault with multi-factor authentication',
    settings_setupGuide: 'Integration Protocol',
    settings_units: 'Measurement Units',
    settings_restaurantType: 'Business Classification',
    settings_restaurant: 'Restaurant',
    settings_cafe: 'Café',
    settings_bakery: 'Patisserie/Bakery',
    settings_foodTruck: 'Food Truck / Pop-up',
    settings_cloudKitchen: 'Cloud Kitchen',
    settings_other: 'Other',

    // ZATCA & National Address
    settings_zatcaTitle: 'E-Invoicing Data (ZATCA)',
    settings_zatcaDesc: 'Official VAT registration information',
    settings_zatcaMandatory: 'Restricted / Mandatory',
    settings_zatcaReason: 'To ensure adherence to the Kingdom of Saudi Arabia Phase 2 electronic invoicing mandate',
    settings_vatNumber: 'VAT Registration Number',
    settings_crNumber: 'Commercial Registration (CR)',
    settings_vatHint: '15 digits, starting with 3',
    settings_nationalAddress: 'Official National Address',
    settings_buildingNumber: 'Building No.',
    settings_streetName: 'Street Name',
    settings_district: 'District',
    settings_city: 'City',
    settings_postalCode: 'Postal Code',
    settings_postalHint: '5 digits',
    settings_additionalNumber: 'Secondary No.',
    settings_additionalHint: '4 digits',
    settings_deviceSerial: 'Hardware Serial No. (Optional)',
    settings_timezoneRiyadh: 'Riyadh Zone (GMT+3)',

    // Activity Types for Registration
    type_restaurant: 'Restaurant',
    type_cafe: 'Café',
    type_juice: 'Juice Shop',
    type_bakery: 'Bakery / Sweets',
    type_sweets: 'Confectionery',
    type_cafeteria: 'Cafeteria / Buffet',
    type_food_truck: 'Food Truck',
    type_other: 'Other Venture',

    // Menu Offers / Slides
    settings_menuBannersTitle: 'Premium Menu Banner Management',
    settings_menuBannersDesc: 'Interactive slides that captivate customers at the top of your digital menu.',
    settings_slideTitle: 'Banner Headline',
    settings_slideSubtitle: 'Promotional Sub-headline',
    settings_slideImageUrl: 'Banner Visual URL',
    settings_addSlide: 'Deploy New Banner',
    settings_removeSlide: 'Archive',
    settings_noSlides: 'No active banners currently deployed',

    // Dashboard Guide Steps
    dashGuide_title: 'Platform Excellence Guide',
    dashGuide_step1Title: 'Real-Time Operational Pulse',
    dashGuide_step1Desc: 'Monitor your financial health with the live pulse dashboard, refreshing every 30 seconds.',
    dashGuide_step2Title: 'Intelligence-Driven Decisions',
    dashGuide_step2Desc: 'Our integrated AI analyzes patterns to suggest maneuvers for higher profit and reduced waste.',
    dashGuide_step3Title: 'Compliance Surveillance',
    dashGuide_step3Desc: 'Automatic verification of your ZATCA integration and SFDA logs for a worry-free operation.',
    dashGuide_step4Title: 'Live Customer Heatmap',
    dashGuide_step4Desc: 'Visualize table turnover and occupancy real-time to optimize server rotations.',
    dashGuide_tip1: 'Use "Instant Actions" for your most frequent administrative maneuvers.',
    dashGuide_tip2: 'A "Green" health status indicates your business infrastructure is running at peak capacity.',
    dashGuide_tip3: 'AI recommendations gain precision as your order history expands.',
    dashGuide_sfda1: 'The dashboard creates an immutable audit trail for official regulatory inspections.',
    dashGuide_sfda2: 'Batch tracking alerts are highlighted here to mitigate food safety risks instantly.',

    // Sidebar & Vendor Layout extra
    returnsHistory: 'Returns History',
    reputationManagement: 'Reputation & Customer Management',
    sfdaCompliance: 'SFDA Compliance',
    rawMaterials: 'Raw Materials',
    warehouses: 'Warehouses',
    replenishment: 'Replenishment',
    stockAlerts: 'Stock Alerts',
    inventoryReports: 'Inventory Reports',

    // Purchase Returns Page
    purchaseReturnsManagement: 'Purchase Returns Management',
    purchaseReturnsSubtitle: 'Manage and track purchase returns with inventory updates',
    createNewReturn: 'Create New Return',
    availableInvoices: 'Available Invoices for Return',
    availableInvoicesSubtitle: 'Paid invoices can be returned within the allowed period',
    createReturn: 'Create Return',
    noInvoicesForReturn: 'No invoices available for return',
    returnDate: 'Return Date',
    returnReason: 'Return Reason',
    selectReason: 'Select Reason',
    defective: 'Defective Product',
    wrongItem: 'Wrong Item',
    excessQuantity: 'Excess Quantity',
    expired: 'Expired',
    damaged: 'Damaged',
    qualityIssue: 'Quality Issue',
    other: 'Other',
    selectItemsToReturn: 'Select Items to Return',
    originalQty: 'Original Quantity',
    returnQty: 'Return Quantity',
    returnTotal: 'Return Total',
    confirmReturn: 'Confirm Return',
    returnCreatedSuccess: 'Purchase return created successfully!',
    returnCreatedNote: 'Inventory has been updated and a credit note has been issued.',
    selectAtLeastOneItem: 'Please select at least one item to return',
    enterReturnReason: 'Please enter a return reason',
    failedToCreateReturn: 'Failed to create return',

    // Customers Page extra
    addCustomer: 'Add Customer',
    customerName: 'Customer Name',
    customerEmail: 'Email',
    customerPhone: 'Phone',
    country: 'Country',
    region: 'Region',
    city: 'City',
    district: 'District',
    buildingNumber: 'Building Number',
    street: 'Street',
    postalCode: 'Postal Code',
    contactPerson: 'Contact Person',
    website: 'Website',
    fax: 'Fax',
    priceLevel: 'Price Level',
    standard: 'Standard',
    vip: 'VIP',
    wholesale: 'Wholesale',
    paymentPeriod: 'Payment Period (days)',
    isActive: 'Active',
    saveCustomerSuccess: 'Customer saved successfully',
    updateCustomerSuccess: 'Customer updated successfully',
    general: 'General',
    addressDetails: 'Address & Details',
    totalPayments: 'Total Payments',

    // Delivery Integrations
    deliveryIntegrations: 'Global Delivery Ecosystem',
    integrationsSubtitle: 'Synchronize your menu and orders with leading regional delivery platforms.',
    saveSettings: 'Commit Modifications',
    connected: 'Active (Connected)',
    disconnected: 'Inactive (Offline)',
    autoAcceptOrders: 'Automated Order Acceptance',
    lastSynced: 'Last platform synchronization',
    queue: 'Customer Flow Management',
    queueManagement: 'Queue Orchestration',
    queueSubtitle: 'Intelligent tracking and notification system for waitlisted guests.',
    addToQueue: 'Register New Guest in Queue',
    waitingNow: 'Awaiting Table',
    notified: 'Guest Notified',
    seated: 'Guest Seated',
    notify: 'Dispatch Notification',
    partySize: 'Guest Count',
    waitTime: 'Elapsed Wait Duration',
    noWaitingCustomers: 'Queue is currently clear',
    waiting: 'Awaiting',

    // Offline Mode Architecture
    offlineMode: 'Resilient Offline Operations',
    youAreOffline: 'System Connectivity Interrupted',
    offlineDescription:
        'The DFOOD infrastructure is currently operating in resilient offline mode. Transactions are securely cached locally and will synchronize with the cloud vault upon network restoration.',
    offlineBadge: 'RESI-OFFLINE',
    syncingSoon: 'Awaiting cloud synchronization...',

    // Delivery Performance & Settlements
    deliveryStatements: 'Delivery Settlement Reports',
    deliveryStatementsSubtitle: 'Monitor detailed performance analytics and financial settlements for delivery partners.',
    pricingRules: 'Dynamic Pricing Engine',
    priceMarkup: 'Platform Markup (Global)',
    enableDiscounts: 'Deploy Platform Promotions',
    discountPercent: 'Promotional Depth (%)',
    totalCommissions: 'Projected Platform Commissions',
    netDue: 'Final Net Settlement',
    orderTotal: 'Gross Order Value',
    commission: 'Platform Fee',
    net: 'Net Realized Revenue',
    orderId: 'Platform Reference ID',
    provider: 'Delivery Fleet Provider',
    filter: 'Data Intelligence Filter',
    export: 'Export Dataset',

    // Digital Experience & Marketing
    marketingAndScreens: 'Marketing & Digital Experience',
    marketingSubtitle: 'Command your digital signage, self-service kiosks, and real-time customer touchpoints.',
    marketingGuide: 'Digital Experience Orchestration Guide',
    content: 'Creative Media Assets',
    screens: 'Digital Display Fleet',
    customerDisplay: 'Customer Facing Interface (CFD)',
    selfKiosk: 'Self-Ordering Ecosystem',
    printableMenu: 'Precision Menu Designer (Print-Ready)',

    // Digital Signage Protocol
    digitalMarketingGuideTitle: 'Digital Signage & Engagement Protocol',
    guide_marketing_step1_title: '1. Synchronize Display Network',
    guide_marketing_step1_desc:
        'Instantly broadcast your menu to any smart TV or tablet by generating an encrypted display link.',
    guide_marketing_step2_title: '2. Media Asset Curation',
    guide_marketing_step2_desc:
        'Upload high-fidelity offer visuals and define professional transition sequences to maximize guest engagement.',
    guide_marketing_step3_title: '3. Real-Time Customer Dynamics',
    guide_marketing_step3_desc:
        'Deploy a secondary display at the point of sale to exhibit order precision and personalized brand messaging.',
    guide_marketing_step4_title: '4. Autonomous Kiosk Deployment',
    guide_marketing_step4_desc:
        'Optimize your self-ordering interface with cinematic attractor screens to accelerate peak-hour throughput.',
    guide_marketing_step5_title: '5. High-Fidelity Print Engine',
    guide_marketing_step5_desc:
        'Transform your digital catalogue into a professionally formatted paper menu ready for high-resolution printing.',

    marketing_tip1: 'Recommended visual fidelity: 1920x1080 (HD) for optimal clarity on commercial-grade displays.',
    marketing_tip2: 'Use temporal scheduling to automate offer rotation based on peak demand periods.',
    marketing_tip3: 'Reset display security keys periodically to maintain operational integrity.',
    marketing_sfda1: 'Ensure all digital content strictly adheres to local cultural standards and SFDA visual protocols.',
    marketing_sfda2: 'All physical menus must legally include a QR link to the officially registered digital price list.',

    // Kiosk Administration
    manageSelfKiosk: 'Kiosk System Administration',
    kioskSubtitle: 'Fine-tune the autonomous ordering persona and attractor sequences.',
    kioskManagement: 'Kiosk Orchestration',
    kioskSettingsGeneral: 'Core Configuration',
    kioskMenuControl: 'Catalog Visibility',
    attractorInterface: 'Attractor Screen Architecture',
    attractorTitleLabel: 'Primary Headline',
    attractorSubtitleLabel: 'Operational Prompt',
    paymentMethodsAllowed: 'Authorized Payment Protocols',
    electronicPayment: 'Digital Settlement (Mada, Visa, Apple Pay)',
    cashOnDeliverySoon: 'Physical Settlement (Upon Receipt) - Scheduled',
    attractorImagesScroll: 'Cinematic Visual Sequences (Image URLs)',
    saveAndBroadcast: 'Authorize & Synchronize Changes',
    kioskPreviewLabel: 'Terminal Live Simulation',
    kioskMenuTitle: 'Kiosk-Specific Catalog Orchestration',
    kioskMenuDesc: 'Define which categories and SKUs are accessible via self-service terminals.',
    kioskVisibility: 'Terminal Visibility',
    kioskShow: 'Enabled',
    kioskHide: 'Restricted',
    kioskPreviewBtn: 'Launch Simulation',
    copyKioskLink: 'Copy Terminal URI',
    kioskGuideTitle: 'Strategic Kiosk Orchestration Guide',

    // Floor Plan / Table Management
    floorPlanTitle: 'Spatial Intelligence & Floor Design',
    floorPlanSubtitle: 'Architect your physical establishment layout with precision dragging.',
    editSpatialLayout: 'Authorize Layout Modification',
    saveSpatialLayout: 'Commit Spatial Configuration',
    addNewTable: 'Initialize New Spatial Node (Table)',
    tableProperties: 'Node Specifications',
    tableNumberLabel: 'Table Identifier',
    nodeCapacity: 'Node Capacity (Guests)',
    nodeShape: 'Geometry',
    nodeRotation: 'Angular Orientation',
    deleteNode: 'Decommission Node',
    identifyNode: 'Select a node to modify its attributes or spatial footprint.',
    spatialStats: 'Operational Spatial Insights',
    nodeStatusAvailable: 'Ready/Optimized',
    nodeStatusOccupied: 'Occupied/Revenue Active',
    printableMenuDesigner: 'Precision Print Designer',
    printableMenuSubtitle: 'Architect a premium physical menu optimized for professional print environments.',
    publishContent: 'Broadcast Content to Network',

    // Financial Reconciliation Protocol
    newReconciliationSession: 'Initiate Bank Reconciliation Protocol',
    statementBalanceFinal: 'Certified Statement Balance',
    bankBalance: 'Verified Financial Balance',
    ready: 'Synchronization Status: Ready',
    selectTwoItems: 'Correlate transaction pairs to confirm balance integrity',
    bankStatementIn: 'Inbound Bank Statement Stream',
    systemLedger: 'Internal Financial Ledger',
    allMatched: 'Data successfully reconciled - zero discrepancies detected.',
    createAdjustmentEntry: 'Generate Reconciliation Correction',
    adjustStatementLineHint: 'You are preparing an adjustment entry for the following bank movement:',
    chooseAdjustmentAccount: 'Offset General Ledger Account (e.g., Bank Fees)',
    confirmAdjustment: 'Authorize Correction',
    bankAccountLabel: 'Target Bank Account',

    postConfirm: 'Are you sure you want to post this voucher? This action cannot be undone.',
    postSuccess: 'Posted successfully',
    voucher: 'Voucher',

    // Inventory Page
    smartInventory: 'Smart Inventory Management',
    smartInventorySubtitle: 'Precise tracking, smart alerts, and full control over your warehouse.',



    // Home Page
    home_hero_title: 'The All-in-One Restaurant Management Platform',
    home_hero_subtitle: 'Menu, Inventory, POS, and Accounting – DFOOD gives your restaurant the power of modern tech simply.',
    home_cta_start_free: 'Start Free Trial (14 Days)',
    home_cta_demo: 'Book a Demo',

    home_features_title: 'All Tools to Grow Your Restaurant',
    home_feature_inventory: 'Smart Inventory',
    home_feature_inventory_desc: 'Track ingredients precisely, manage expiry dates, and comply with SFDA regulations.',
    home_feature_delivery: 'Delivery Integration',
    home_feature_delivery_desc: 'Receive Jahez & HungerStation orders in one screen without distraction.',
    home_feature_zatca: 'ZATCA E-Invoicing',
    home_feature_zatca_desc: 'Issue Phase 2 compliant electronic invoices automatically.',
    home_feature_ai_menu: 'AI Smart Menu',
    home_feature_ai_menu_desc: 'Generate dish descriptions and photos using AI with one click.',
    home_feature_kds: 'Kitchen Display System (KDS)',
    home_feature_kds_desc: 'Organize orders between cashier and kitchen to speed up service.',
    home_feature_loyalty: 'Loyalty Programs',
    home_feature_loyalty_desc: 'Retain customers with a smart points and coupons system.',
    home_feature_hr: 'HR & Payroll',
    home_feature_hr_desc: 'Manage payrolls, attendance, and work schedules effortlessly.',

    home_testimonials_title: 'What Our Clients Say',
    home_testimonial1_content: 'Using the integrated DFOOD platform, our sales increased by 30%. The system covers everything from accounting to inventory with amazing accuracy.',
    home_testimonial2_content: 'The platform saved a lot of time and resources. We no longer need external accounting systems, everything is interconnected.',
    home_testimonial3_content: 'The electronic payment system and analytical reports completely changed the way we work. We highly recommend it.',
    home_faq_title: 'Frequently Asked Questions',
    home_pricing_title: 'Plans for Everyone',

    home_footer_copyright: 'All Rights Reserved DFOOD © 2026',
    home_nav_features: 'Features',
    home_nav_how_it_works: 'How it Works',
    home_nav_pricing: 'Pricing',
    home_nav_testimonials: 'Testimonials',
    home_nav_faq: 'FAQ',
    home_login: 'Login',
    home_register: 'Create Account',

    home_step1_title: 'Register Account',
    home_step1_desc: 'Enter your restaurant details and upload logo in under a minute.',
    home_step2_title: 'Upload Menu',
    home_step2_desc: 'Use AI to add dishes and their photos automatically.',
    home_step3_title: 'Start Selling',
    home_step3_desc: 'Print QR Codes, place them on tables, and start receiving orders.',
    home_how_it_works_title: 'Start Selling in 3 Simple Steps',
    home_how_it_works_subtitle: 'No technical experience required.',

    home_get_started_today: 'Start Your Restaurant Digital Transformation Today',
    home_join_thousands: 'Join over 5,000 restaurants trusting DFOOD.',
    home_no_credit_card: 'No credit card required for trial.',

    home_announcement_promo: 'Special Offer: Get 3 months FREE with an annual subscription!',
    home_announcement_cta: 'Subscribe Now',

    home_stats_title: 'Real Impact in Numbers',
    home_stats_subtitle: 'Join hundreds of restaurants leveraging our tech',
    home_stats_restaurants: 'Restaurants & Cafés',
    home_stats_orders: 'Daily Orders',
    home_stats_satisfaction: 'Customer Satisfaction',
    home_stats_support: '24/7 Expert Support',

    home_comparison_subtitle: 'Digital Transformation',
    home_comparison_title: 'A Tangible Business Difference',
    home_comparison_desc: 'Experience how our integrated platform redefines your operational blueprint',
    home_comparison_before: 'The Traditional Way (Manual)',
    home_comparison_after: 'The DFOOD Way (Intelligent)',
    home_comparison_cta: 'Launch Your Transformation Today',
    home_comparison_before_1: 'Fragile paper menus requiring constant reprinting',
    home_comparison_before_2: 'Substantial monthly operational & printing costs',
    home_comparison_before_3: 'Significant time lag for price & availability updates',
    home_comparison_before_4: 'Opaque inventory tracking and order leakage',
    home_comparison_before_5: 'Frequent human errors in order processing',
    home_comparison_after_1: 'Dynamic digital menus that synchronize instantly',
    home_comparison_after_2: 'Save up to 80% on operational & printing overhead',
    home_comparison_after_3: 'Instant menu manipulation with a single click',
    home_comparison_after_4: 'High-fidelity real-time tracking for every SKU',
    home_comparison_after_5: '100% precision in order orchestration & fulfillment',

    home_awards_title: 'Excellence & Recognitions',
    home_awards_subtitle: 'Built on industry trust and peak operational performance',
    home_award_1_title: 'Best Digital Platform 2025',
    home_award_1_org: 'Saudi Tech Excellence Awards',
    home_award_2_title: '4.9/5 Across Leading Review Platforms',
    home_award_2_org: 'From 500+ satisfied establishment owners',
    home_award_3_title: 'Certified Technical E-Invoicing Partner',
    home_award_3_org: 'Zakat, Tax and Customs Authority (ZATCA)',
    home_award_4_title: 'Fastest Growing Hospitality SaaS',
    home_award_4_org: '2025 Industry Growth Report',

    home_pricing_subtitle: 'Precision Pricing',
    home_pricing_desc: 'Strategic Investment for Scalable Growth',
    home_pricing_note: 'Choose the architecture that fits your current scale, with seamless upgrade paths.',
    home_pricing_compare_subtitle: 'Granular Comparison',
    home_pricing_compare_title: 'Analyze Feature Architecture',
    home_pricing_compare_desc: 'Select the optimal package based on your operational complexity',
    home_pricing_features_label: 'Core Capabilities',
    home_pricing_basic: 'Essentials Tier',
    home_pricing_growth: 'Growth Engine 🚀',
    home_pricing_enterprise: 'Enterprise Cloud',
    home_pricing_popular: 'Most Deployed Solution',
    home_pricing_cta_start: 'Launch Free Trial',
    home_pricing_cta_contact: 'Consult with Sales',
    home_pricing_tip: 'Note: All tiers include continuous updates and flexible cancellation',
    home_pricing_tax_note: 'Prices displayed exclude VAT (15%)',

    home_preview_label: 'Centralized Intelligence Dashboard',
    home_preview_title: 'Orchestrate Your Business with Precision',
    home_preview_desc: 'Eliminate system fragmentation. Monitor live P&L, track branch KPIs, manage warehouse logistics, and centralize delivery requests—all from a hyper-fast, cloud-native intelligence hub.',
    home_preview_list_1: 'Real-time synchronization via high-speed WebSockets',
    home_preview_list_2: 'Predictive analytics to drive strategic maneuvers',
    home_preview_list_3: 'Advanced RBAC for secure staff & manager orchestration',
    home_preview_sales: 'Today\'s Total Revenue',
    home_preview_trend: 'Growth Velocity',
    home_preview_new_order: 'Alert: Inbound Transaction Captured',
    home_preview_order_item: 'Premium Family Orchestration',
    home_preview_order_status: 'Captured - In Fulfillment',

    home_sectors_subtitle: 'Industry-Specific Solutions',
    home_sectors_title: 'Engineered for Your Specific Challenges',
    home_sectors_desc: 'We reject one-size-fits-all software. We\'ve engineered precise capabilities that resolve the unique complexities of Bakeries, Cafés, and Cloud Kitchens.',
    home_sectors_cta: 'Discover Your Optimized Plan',
    home_sector_restaurants: 'Fine Dining & Lounges',
    home_sector_bakery: 'Artisanal Bakeries',
    home_sector_cafes: 'Specialty Roasteries',
    home_sector_kitchens: 'High-Volume Cloud Kitchens',

    home_cta_title: 'Ready to Modernize Your Infrastructure?',
    home_cta_desc: 'Join the digital frontrunners today. Deploy a 14-day full-feature trial. No hidden liabilities, no credit card required.',
    home_cta_btn_trial: 'Initialize Free Trial Now',
    home_cta_btn_sales: 'Schedule Architectural Consultation',

    home_footer_desc: 'The Kingdom’s premier technical partner for the hospitality sector. We deploy cutting-edge cloud infrastructure designed to optimize operational efficiency and yield.',
    home_footer_links: 'Core Navigation',
    home_footer_support: 'Knowledge & Support',
    home_footer_blog: 'Tech & Hospitality Insights',
    home_footer_help: 'Integrated Knowledge Base',
    home_footer_api: 'Developer Documentation (API)',
    home_footer_status: 'Infrastructure Pulse Status',
    home_footer_contact: 'Connect with Our Team',
    home_footer_privacy: 'Data Privacy & Security Charter',
    home_footer_terms: 'Operational Terms of Use',
    home_footer_copyright_fixed: 'All Rights Reserved DFOOD © 2026',

    // Auth & Identity Operations
    auth_loginTitle: 'Secure Portal Access',
    auth_loginSubtitle: 'DFOOD Infrastructure — Intelligent Hospitality Orchestration',
    auth_emailLabel: 'Identity (Email)',
    auth_passwordLabel: 'Access Key (Password)',
    auth_forgotPassword: 'Recover Access Cryptography?',
    auth_loginBtn: 'Authenticate & Enter',
    auth_noAccount: 'Unregistered Entity?',
    auth_registerLink: 'Onboard New Venture',
    auth_backToHome: 'Return to Terminal Home',
    auth_registerTitle: 'Venture Onboarding',
    auth_registerSubtitle: 'Initiate your digital transformation in precise steps',
    auth_personalInfo: 'Administrator Identity',
    auth_businessInfo: 'Business Profile Details',
    auth_fullName: 'Legal Full Name',
    auth_businessName: 'Establishment Nomenclature',
    auth_phone: 'Primary Communication Node',
    auth_city: 'Operational Locale / Address',
    auth_businessType: 'Industry Sector',
    auth_registerBtn: 'Initialize Protocol & Deploy Trial',
    auth_confirmPassword: 'Key Verification',
    auth_otpTitle: 'Contact Node Verification',
    auth_otpDesc: 'Input the 6-digit cryptographic code dispatched to {phone} via WhatsApp',
    auth_verifyBtn: 'Verify Identity & Initialize',
    auth_resendOtp: 'Re-dispatch protocol available in {timer}s',
    auth_resendOtpNow: 'Re-dispatch Security Code',
    auth_changePhone: 'Modify Contact Node',
    auth_successTitle: 'Inquiry Successfully Dispatched!',
    auth_successDesc: 'Your business profile is currently undergoing architectural review. Notification will be dispatched upon activation.',
    auth_benefit1_title: 'Dynamic Smart Cataloging',
    auth_benefit1_desc: 'Instant synchronization of inventory pricing and visual assets.',
    auth_benefit2_title: 'Frictionless Guest Experience',
    auth_benefit2_desc: 'Browser-native interaction. No third-party installation required.',
    auth_benefit3_title: 'Data Intelligence Hub',
    auth_benefit3_desc: 'Execute strategic maneuvers based on high-fidelity analytics.',
    auth_welcomeTitle: 'Join the Future of Digital Hospitality',
    auth_welcomeTitle_br: 'Join the Future of Digital Hospitality',
    auth_welcomeTitle_highlight: 'Digital Hospitality',
    auth_welcomeDesc: 'Integrated platform giving you full control over your restaurant, from interactive digital menus to inventory and sales management.',
    auth_menuTheme: 'Preferred Menu Theme',
    auth_menuTheme_hint: 'You can easily change the design later from the dashboard.',
    theme_classic: 'Classic',
    theme_luxury: 'Luxury',
    theme_premium: 'Modern',
    auth_version: 'v2.0 Professional',
    auth_2faTitle: 'Multi-Factor Authentication (MFA)',
    auth_2faDesc: 'Input the verification token from your preferred authenticator app',
    auth_verifyLogin: 'Authorize & Synchronize',

    // Register Page Specific
    create_new_account: 'Create New Account',
    start_digital_journey_desc: 'Start your digital transformation journey today.',
    account_officer_data: 'Account Officer Data',
    full_name: 'Full Name',
    password: 'Password',
    confirm_password: 'Confirm Password',
    establishment_data: 'Establishment Data',
    restaurant_name: 'Restaurant / Business Name',
    activity_type: 'Activity Type',
    bakery: 'Bakery',
    juice: 'Juice Shop',
    cafe: 'Cafe',
    restaurant: 'Restaurant',
    sweets: 'Sweets',
    cafeteria: 'Cafeteria',
    food_truck: 'Food Truck',
    creating_account: 'Creating account...',
    create_and_start_trial: 'Create Account and Start Trial',
    verify_your_phone: 'Verify Your Phone',
    enter_otp_sent_to: 'Enter verification code sent to',
    via_whatsapp: 'via WhatsApp',
    verifying: 'Verifying...',
    confirm_and_create_account: 'Confirm and Create Account',
    resend_otp_in: 'Resend code in',
    seconds: 'seconds',
    resend_otp_now: 'Resend code now',
    change_phone_number: 'Change phone number',
    registration_success_title: 'Account Created Successfully!',
    registration_success_desc: 'Welcome to DFOOD family. You can now start setting up your restaurant.',
    account_created_successfully: 'Account Created Successfully',
    account_pending_review_message: 'Your account is under administrative review. We will activate it soon and provide you with all details.',
    go_to_login: 'Go to Login',
    back_to_home: 'Back to Home',

    // New Registration UI Keys
    join_future: 'Join the Future of',
    digital_hospitality: 'Digital Hospitality',
    platform_desc: 'Integrated platform giving you full control over your restaurant, from interactive digital menus to inventory and sales management.',
    benefit1_title: 'Smart Interactive Menus',
    benefit1_desc: 'Instant price updates and product images at the touch of a button.',
    benefit2_title: 'Seamless Guest Experience',
    benefit2_desc: 'No app download required, just scan and order.',
    benefit3_title: 'Reports & Analytics',
    benefit3_desc: 'Make decisions based on accurate, real-time data.',

    full_name_placeholder: 'e.g. John Doe',
    restaurant_name_placeholder: 'e.g. Gourmet Burger',
    address_placeholder: 'e.g. Riyadh, Olaya St.',
    otp_sent_success: 'Verification code sent via WhatsApp',
    enter_6_digit_otp: 'Please enter the 6-digit code',
    creating_account_loading: 'Creating account...',

    // Input Validation Protocols
    val_emailRequired: 'Identity (Email) mandatory',
    val_emailInvalid: 'Invalid email syntax detected',
    val_passwordRequired: 'Access Key required for authentication',
    val_otpRequired: 'Verification token mandatory',
    val_nameRequired: 'Legal name is required for profile creation',
    val_passwordShort: 'Access key must exceed 8 alphanumeric characters',
    val_passwordMismatch: 'Password verification failed - keys do not correlate',
    val_businessNameRequired: 'Establishment name is mandatory',
    val_phoneRequired: 'Communication node (phone) required',
    val_phoneShort: 'Insufficient character length for contact node',
    val_addressRequired: 'Physical operational address is mandatory',
    val_typeRequired: 'Selection of industry sector is mandatory',

    // Register extra validations
    name_required: 'Full name is required',
    email_required: 'Email address is required',
    invalid_email: 'Invalid email address',
    password_required: 'Password is required',
    password_min_length: 'Password must be at least 8 characters',
    passwords_not_match: 'Passwords do not match',
    restaurant_name_required: 'Business name is required',
    phone_required: 'Phone number is required',
    phone_too_short: 'Phone number is too short',
    address_required: 'Address is required',
    activity_required: 'Activity type is required',

    // New Keys for HomePage Refactor
    no_limit: 'Unlimited',
    apps: 'Apps',
    custom: 'Custom',
    basic: 'Basic',
    advanced: 'Advanced',
    training: 'Training & Onboarding',
    account_manager: 'Dedicated Account Manager',
    home_mockup_restaurant_name: 'Burger House',
    home_mockup_category_all: 'All',
    home_mockup_category_burger: 'Burger',
    home_mockup_category_pizza: 'Pizza',
    home_mockup_category_drinks: 'Drinks',
    home_mockup_product_name: 'Double Cheese Burger',
    home_mockup_product_desc: 'Wagyu beef, cheddar cheese, special sauce',
    home_mockup_discount_title: '20% Discount',
    home_mockup_discount_desc: 'Across all family meals',

    // Register Page Missing Keys (Synced with RegisterPage.jsx)
    phone_contact: 'Contact Phone Number',
    city_address: 'City / Physical Address',
    city_address_placeholder: 'e.g. Riyadh, Olaya St.',

    // Daily Journal & Accounting
    allUsers: 'All Users',
    journalEntriesTotal: 'Journal Entries Stats',
    currentBalance: 'Balance Difference',
    allTypes: 'All Types',
    manual: 'Manual',
    automated: 'Automated',
    reversal: 'Reversal',
    showing: 'Showing',
    entryDetails: 'Entry Details',
    newJournalEntry: 'New Journal Entry',
    manualJournalEntryDesc: 'Record a manual accounting entry in the general ledger.',
    reversalReason: 'Reversal Reason',
    minAmount: 'Min Amount',
    maxAmount: 'Max Amount',
    referenceType: 'Reference Type',
    postedBy: 'Posted By',

    // Security & Preferences Tab Settings
    settings_dateTimeFormats: 'Date & Time Formats',
    dateFormat: 'Date Format',
    timeFormat: 'Time Format',
    settings_passwordPolicies: 'Password Strength Policies',
    passwordMinLength: 'Minimum Password Length',
    sessionTimeoutMinutes: 'Session Timeout (Minutes)',
    requireUppercase: 'Require Uppercase Letters (A-Z)',
    requireUppercaseDesc: 'Password must contain at least one uppercase letter.',
    requireLowercase: 'Require Lowercase Letters (a-z)',
    requireLowercaseDesc: 'Password must contain at least one lowercase letter.',
    requireNumbers: 'Require Numbers (0-9)',
    requireNumbersDesc: 'Password must contain at least one number.',
    requireSymbols: 'Require Special Symbols (#$%!)',
    requireSymbolsDesc: 'Password must contain at least one special symbol.',
    mustChangePasswordNext: 'Force employees to change password on next login',
    mustChangePasswordDesc: 'All newly created employees will be forced to set a new password on their first login.',
    twoFactorAuth: 'Two-Factor Authentication (2FA)',

    // POS Open Price Modal Settings
    pos_openPriceTitle: 'Set Open Price',
    pos_productLabel: 'Product:',
    pos_invalidPriceError: 'Please enter a valid price greater than zero',
    pos_clearField: 'Clear Field',
    pos_hideNote: 'Hide Note',
    pos_addNote: 'Add Note',
    pos_notePlaceholder: 'Add a note or reason for modifying the price...',
    pos_confirmPrice: 'Confirm Price',

    // Missing Keys from Arabic Dictionary
    recentOrders: 'Recent Orders',
    purchaseInvoices: 'Purchase Invoices',
    salesReportsTitle: 'Sales & Customers Reports',
    salesReportsSubtitle: 'Comprehensive analysis of sales, shifts, and customer aging debt.',
    avgOrder: 'Average Order',
    numOrders: 'Number of Orders',
    dailySales: 'Daily Sales',
    topProducts: 'Top Selling Products',
    soldQty: 'Sold Qty',
    percentage: 'Percentage',
    shiftsHistory: 'Shifts History',
    invoiceSearch: 'Invoice Search',
    agingReportTab: 'Aging Debt Report',
    shiftNumber: 'Shift Number',
    startTime: 'Start Time',
    endTime: 'End Time',
    status: 'Status',
    openingCash: 'Opening Cash',
    expectedCash: 'Expected Cash',
    actualCash: 'Actual Cash',
    actions: 'Actions',
    noShiftsFound: 'No shift records found for this period',
    searchShiftHint: 'Enter shift number to search linked orders...',
    printReport: 'Print Report',
    invoiceNumber: 'Invoice Number',
    time: 'Time',
    noInvoicesFound: 'No invoices found for this shift',
    searchShiftPrompt: 'Enter shift number to search',
    days31_60: '31-60 Days',
    days61_90: '61-90 Days',
    days90_plus: '+90 Days',
    totalDue: 'Total Due',
    openKiosk: 'Open Kiosk',
    attractorTitle: 'Attractor Screen Title (Huge Title)',
    attractorTitlePlaceholder: 'Example: Hungry?',
    attractorSubtitlePlaceholder: 'Example: Order now with a single touch',
    attractorImages: 'Attractor Images (URLs - displayed as a slideshow)',
    saveKioskSettings: 'Save Kiosk Settings',
    startOrdering: 'Start Ordering',
    kioskPreview: 'Kiosk Interface Preview',
    sidebar_staffList: 'Staff List',
    whatsapp_verification: 'WhatsApp Verification',
    otp_sent_message: 'Verification code sent to phone number:',
    verify_and_continue: 'Verify & Continue',
    resend_code_in_seconds: 'Resend code in {seconds} seconds',
    change_phone_label: 'Change Phone Number',
    create_account: 'Create Account Now',
    back_to_login: 'Back to Login',
    or: 'or',
    otp_not_received_hint: 'Code not received? You can use manual override code for admins.',
    sidebar_accounting: 'Integrated Accounting System',
    sidebar_inventory: 'Warehouse & Inventory Management',
    sidebar_purchases: 'Purchase & Supply Operations',
    sidebar_staff: 'Staff Affairs & Payroll',
    sidebar_marketing: 'Marketing & Sales Growth',
    sidebar_settings: 'Establishment Settings',
    numberFormatLabel: 'System Number Formatting',
    numberFormatEnglish: 'English Numerals (123...)',
    numberFormatArabic: 'Arabic Numerals (١٢٣...)',
    numberFormatPreview: 'Live Number Preview in Reports/Invoices:',
    roundingDifferenceAccount: 'Rounding Difference Account',
    payrollAndAssetsAccounts: 'Payroll and Assets Accounts',
    salaryExpenseAccount: 'Salary Expense Account',
    salaryPayableAccount: 'Salary Payable Account',
    depreciationExpenseAccount: 'Depreciation Expense Account',
    accumulatedDepreciationAccount: 'Accumulated Depreciation Account',
};
